const HeroSection = () => {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="intro"
      className="relative w-full h-screen min-h-[600px] flex items-center justify-center overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/423984dcef1cbbaa0ee876f17d19c551.jpg"
          alt="전립선 건강에 좋은 과일과 채소 배경"
          className="w-full h-full object-cover object-center"
        />
        {/* Dark overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-[#1a2b4a]/40 via-[#1a2b4a]/55 to-[#1a2b4a]/40" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full text-center px-6 flex flex-col items-center">
        <p className="text-white/80 text-sm md:text-base tracking-[0.3em] uppercase mb-6 font-light" style={{textShadow:'0 2px 8px rgba(0,0,0,0.5)'}}>
          Proactive Care Series
        </p>
        <h1 className="text-white text-5xl md:text-7xl lg:text-8xl font-bold leading-tight mb-6 tracking-tight" style={{textShadow:'0 4px 16px rgba(0,0,0,0.55)'}}>
          프로엑티브케어
        </h1>
        <p className="text-2xl md:text-3xl mb-6 font-bold tracking-wide leading-snug" style={{color:'#f5e6c8', textShadow:'0 3px 14px rgba(0,0,0,0.55)'}}>
          전립선암 식단에<br />최적화된 건강기능식품
        </p>
        <p className="text-white/80 text-base md:text-lg mb-8 max-w-xl" style={{textShadow:'0 2px 8px rgba(0,0,0,0.45)'}}>
          전립상회는 환자의 건강을 최우선으로 생각합니다.
        </p>

        {/* Award Badge */}
        <div className="flex items-center gap-2.5 bg-white/10 backdrop-blur-sm border border-[#d4a843]/50 rounded-full px-5 py-2.5 mb-8">
          <div className="w-5 h-5 flex items-center justify-center">
            <i className="ri-award-fill text-[#f0c040] text-base" />
          </div>
          <span className="text-white/90 text-xs font-medium tracking-wide">2024 한국소비자산업평가 &nbsp;·&nbsp; 건강 분야 비타민제 부문 <span className="text-[#f0c040] font-bold">우수상</span></span>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 items-center">
          <button
            onClick={() => scrollTo('products')}
            className="bg-white text-[#1a2b4a] text-sm font-semibold px-8 py-3.5 rounded-md hover:bg-gray-100 transition-all duration-200 cursor-pointer whitespace-nowrap tracking-wide"
          >
            제품소개
          </button>
          <a
            href="https://smartstore.naver.com/proactivecare"
            target="_blank"
            rel="noopener noreferrer"
            className="border-2 border-white text-white text-sm font-semibold px-8 py-3.5 rounded-md hover:bg-white/10 transition-all duration-200 cursor-pointer whitespace-nowrap tracking-wide"
          >
            구매하기
          </a>
        </div>

        {/* Scroll indicator */}
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
          <span className="text-white/50 text-xs tracking-widest uppercase">Scroll</span>
          <div className="w-5 h-5 flex items-center justify-center">
            <i className="ri-arrow-down-line text-white/50 text-lg" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
